import { createContext, type ReactNode, useCallback, useContext, useState } from 'react';
import { RentalManagerFreemiumAnalyticsFilterType } from '@zg-rentals/ts-rental-manager-api-beta-client';
import type { Filters, PremiumAnalyticsContextValue } from './types';

const PremiumAnalyticsContext = createContext<PremiumAnalyticsContextValue | undefined>(undefined);

export const usePremiumAnalyticsContext = () => {
  const context = useContext(PremiumAnalyticsContext);
  if (!context) {
    throw new Error('usePremiumAnalyticsContext must be used within PremiumAnalyticsProvider');
  }
  return context;
};

type Props = {
  children: ReactNode;
};

export const PremiumAnalyticsProvider = ({ children }: Props) => {
  const [filters, setFilters] = useState<Filters>({
    filterType: RentalManagerFreemiumAnalyticsFilterType.CITY_STATE,
    beds: undefined,
    propertyType: undefined,
  });

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [updatedTimestamps, setUpdatedTimestamps] = useState<Array<number>>([]);

  const addUpdatedTimestamp = useCallback((timestamp: number) => {
    setUpdatedTimestamps((prev) => [...prev, timestamp]);
  }, []);

  const value: PremiumAnalyticsContextValue = {
    filters,
    setFilters,
    isFilterModalOpen,
    setIsFilterModalOpen,
    updatedTimestamps,
    addUpdatedTimestamp,
  };

  return <PremiumAnalyticsContext.Provider value={value}>{children}</PremiumAnalyticsContext.Provider>;
};
